export const WMC_ROUTE_PATHS = {
  list: '/ops-hub/withdrawal-method-config',
  new: '/ops-hub/withdrawal-method-config/new',
  edit: '/ops-hub/withdrawal-method-config/$id',
};

const PANEL_PREFIX = '/v1/api/platform/merchant-withdrawal-method-config';

export const WMC_API_PATHS = {
  list: PANEL_PREFIX,
  create: PANEL_PREFIX,
  update: (id: number | string) => `${PANEL_PREFIX}/${id}`,
  updateStatus: (id: number | string) => `${PANEL_PREFIX}/${id}/status`,
};

export const WMC_QUERY_KEYS = {
  list: 'wmc:list',
  detail: 'wmc:detail',
} as const;

export const WMC_SCOPE = 'withdrawal-method-config';

/** Mirrors the `cashout_mode` column values the backend understands. */
export const CASHOUT_MODE = {
  DIRECT: 'DIRECT',
} as const;
export type CashoutMode = (typeof CASHOUT_MODE)[keyof typeof CASHOUT_MODE];

/** Default pagination size for list view. */
export const WMC_PAGE_SIZE = 25;

